module.exports = __webpack_public_path__ + "img/ic-ic-new-creditcard-w.da2e2f2b.svg";